<template>
  <div class="bookdetail-wrapper">
    <navgation-bar :isDefault="false" v-if="isHideBrown">
      <template v-slot:nav-left>
        <div class="search-container-nav-left" @click="onBackClick">
          <img src="@img/back-white.svg" />
        </div>
      </template>
      <template v-slot:nav-center>
        <p class="search-container-nav-title">
          {{ $t("app.home_detail_title") }}
        </p>
      </template>
    </navgation-bar>

    <div class="book-detail-container">
      <!-- 圖書详情  start-->
      <div class="book-content">
        <div class="book-content-left" @click="photoBrowsn">
          <van-image width="70px" height="100px" cover :src="photo_url" />
          <div class="img-cover">
            <div class="img-cover-item">
              <img src="@img/fullscreen.png" style="width:15px;height:15px;" />
            </div>
          </div>
        </div>
        <div class="book-content-right">
          <div class="book-content-right-directory-wrapper">
            <div
              class="book-content-right-directory"
              v-if="detailData.haddir"
              @click="goDetail"
            >
              <span class=" book-content-right-directory-text">{{
                $t("app.home_ml")
              }}</span>
            </div>
          </div>

          <div class="book-desc-item-content-right-wrapper">
            <div class="book-desc-item-content-right">
              <div v-if="detailData.epublisher != 0">
                <span class="book-desc-item-content-right-currency">MOP</span>
                <span class="book-desc-item-content-right-amount">{{
                  detailData.epublisher
                }}</span>
              </div>
              <div v-else>
                <span class="book-desc-item-content-right-currency">{{
                  $t("app.home_free")
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="book-list-wrapper">
        <div class="book-list-wrapper-item">
          <div class="book-right">
            <div class="book-title">
              <span class="book-title-text">{{ detailData.name }}</span>
            </div>

            <div class="book-desc-wrapper">
              <div class="book-desc-item">
                <span class="book-desc-item-left"
                  >{{ $t("app.home_category") }}：</span
                >
                <span class="book-desc-item-right">{{
                  detailData.itemcategoryname
                }}</span>
              </div>

              <div class="book-desc-item">
                <span class="book-desc-item-left"
                  >{{ $t("app.home_publisher") }}：</span
                >
                <span class="book-desc-item-right">{{
                  detailData.publisher
                }}</span>
              </div>

              <div class="book-desc-item">
                <span class="book-desc-item-left"
                  >{{ $t("app.home_author") }}：</span
                >
                <span class="book-desc-item-right">{{
                  detailData.author
                }}</span>
              </div>

              <div class="book-desc-item">
                <span class="book-desc-item-left"
                  >{{ $t("app.home_publishlang") }}：</span
                >
                <span class="book-desc-item-right">{{
                  detailData.publishlang
                }}</span>
              </div>
              <div class="book-desc-item">
                <span class="book-desc-item-left"
                  >{{ $t("app.home_publishdate") }}：</span
                >
                <span class="book-desc-item-right">{{
                  detailData.publishdate
                }}</span>
              </div>

              <div class="book-desc-item">
                <span class="book-desc-item-left">ISBN：</span>
                <span class="book-desc-item-right">{{
                  detailData.isbnno
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 圖書详情  end-->

      <!-- 售卖机 start-->
      <div class="shop-sale-machine-wrapper">
        <div class="shop-sale-machine-title">
          <span>{{ $t("app.home_soldmaiche") }}</span>
        </div>

        <div
          class="shop-sale-machine-item-wrapper"
          v-for="(item, index) in detailData.sellshop"
          :key="index"
        >
          <div class="shop-sale-machine-item" @click="goHome(item)">
            <div class="item-sold-view">
              <div style=" display: flex; flex-direction: column;">
                <span
                  :class="
                    item.quantity <= 0
                      ? 'shop-sale-machine-item-sold-name'
                      : 'shop-sale-machine-item-name'
                  "
                  >{{ item.name }}</span
                >
                <span
                  :class="
                    item.quantity <= 0
                      ? 'shop-sale-machine-item-sold-addr'
                      : 'shop-sale-machine-item-addr'
                  "
                  >{{ item.addr }}</span
                >
              </div>

              <div v-if="item.quantity <= 0">
                <span
                  :class="item.quantity <= 0 ? 'sold-out-text' : 'sold-text'"
                  >{{ $t("app.home_soldOut") }}</span
                >
              </div>
            </div>

            <van-divider :style="{ padding: '0 0px', width: '100%' }" />
          </div>
        </div>
      </div>

      <!-- 售卖机 end-->
    </div>
  </div>
</template>

<script>
import NavgationBar from "@c/currency/NavigationBar";
import { ImagePreview } from "vant";
import base from "../api/base"; // 导入接口域名列表
import { Toast } from "vant";
import { i18n, vantLocales, app } from "../lang";
export default {
  name: "bookdetail",
  data() {
    return {
      active_: "", //切换 tab 所对应的状态数字
      id: "",
      detailData: {},
      photo_url: "",
      big_image_url: "",
      isHideBrown: true,
      isFromHome: false,
      isBackHome: 0,
      shopId: "",
      shopCode: "" //售卖机的id
    };
  },
  //在路由离开的时候，关闭预览的图片
  // beforeRouteLeave(to, from, next) {
  //   if (this.active_ == 0) {
  //     this.instance_before.close();
  //   } else {
  //     this.instance_after.close();
  //   }
  //   next();
  // },
  name: "bookdetail",
  components: {
    NavgationBar
  },
  created() {
    
    this.shopCode = this.$route.query.shopCode;
    this.id = this.$route.query.itemId;
    this.isBackHome = this.$route.query.isBackHome;
    this.isFromHome = this.$route.query.isFromHome;
    var lang = this.$route.query.lang;
    this.shopId = this.$route.query.shopId; //售卖机地点id

     if(lang){
      window.localStorage.setItem("lang",lang);
       vantLocales(lang);
     }
     
    if (this.shopCode) {
      this.loadDataSoldCode();
    }
    var photo_url =
       window.configUrl.baseURL  + "/mbs/api/item/" + this.id + "/file?type=" + 0; //小图
    var big_image_url =
       window.configUrl.baseURL  + "/mbs/api/item/" + this.id + "/file?type=" + 1; //小图
    this.photo_url = photo_url;
    this.big_image_url = big_image_url;
    this.loadData();
  },
  methods: {
    loadDataSoldCode() {
      var params = {
        shopCode: this.shopCode
      };
debugger
      this.$api.home
        .soldMachineShopCode(this.shopCode)
        .then(res => {
          var data = res.data.data;
          this.shopId = data.shopid;
          debugger;
          var baseUrl = window.location.origin;
          var url =
            baseUrl +
            "/BIMS_MOBILE/bookDetail?" +
            "routerType=" +
            "push&" +
            "isFromHome=" +
            true +
            "&" +
            "isBackHome=" +
            1 +
            "&" +
            "shopId=" +
            this.shopId +
            "&" +
            "itemId=" +
            this.id;
            debugger
          
          window.location.href = url;
        })
        .catch(error => {
          console.log(error);
        });
    },
    goHome(item) {
      if (this.isBackHome) {
        this.$router.replace("/");
        this.$nextTick(() => {
          this.$eventBus.$emit("updateSoldMachineList", item.shopid);
        }, 2000);
      } else {
        this.$eventBus.$emit("updateSoldMachineList", item.shopid);
        if (this.isFromHome) {
          this.$router.go(-1);
        } else {
          this.$router.go(-2);
        }
      }
    },
    loadData() {
      var params = {
        id: this.id
      };
      this.$api.home
        .soldMachineListDetail(this.id)
        .then(res => {
          var data = res.data.data;
          debugger;
          this.detailData = data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    onBackClick() {
      if (this.isBackHome) {
        //单独扫二维码进入该页面
        this.$router.replace("/");
        this.$nextTick(() => {
          this.$eventBus.$emit("updateSoldMachineList", this.shopId);
        }, 2000);
      } else {
        this.$router.go(-1);
      }
    },

    photoBrowsn() {
      var that = this;
      this.isHideBrown = false;
      ImagePreview({
        images: [this.big_image_url],
        closeable: true,
        onClose() {
          that.isHideBrown = true;
        }
      });
    },
    goDetail() {
      var url =  window.configUrl.baseURL  + "/mbs/api/item/" + this.id + "/file?type=" + 2;
      this.$router.push({ name:'catalog', params: { url: url }});
    }
  }
};
</script>

<style lang="scss" scoped>
.book-detail-container {
  width: 100%;

  overflow-y: auto;
}
.bookdetail-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.header-left {
  width: 100%;
  color: black;
  font-size: 15px;
}
.search-container-nav-left {
  display: flex;
}
.header-right-wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 30px;
  justify-content: center;
  align-items: center;
}

.header-right-item-left {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  border-radius: 10px 0px 0px 10px;
  background-color: #2ec180;
  height: 30px;
}

.header-right-item-right {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: #29b179;
  border-radius: 0px 10px 10px 0px;
  height: 30px;
}
.search-container-nav-title {
  color: white;
  font-size: 16px;
}

.header-item-text {
  color: white;
  font-size: 13px;
}

.down-arrow {
  display: flex;
  width: 0px;
  height: 0px;
  border-width: 5px;
  border-style: solid;
  margin-top: 5px;
  margin-left: 1px;
  border-color: white transparent transparent transparent;
}

.book-list-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
}

.book-list-wrapper-item {
  display: flex;
  flex-direction: row;
  background-color: white;
  font-size: 14px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
}

.book-left {
  margin-top: 10px;
  display: flex;
  width: 67px;
  height: 85px;
}

.book-right {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: 10px;
}
.book-title-text {
  color: #000000;
  font-size: 16px;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.book-desc-wrapper {
  margin-top: 10px;
}
.book-desc-item {
  font-size: 13px;
  color: #333333;
  padding: 3px 0px;
  display: flex;
  line-height: 20px;
}
.book-desc-item-left {
  width: 70px;
  color: #666666;
}

.book-desc-item-right {
  flex: 1;
  color: #666666;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // display: -webkit-box;
  // -webkit-line-clamp: 1;
  // -webkit-box-orient: vertical;
}

.book-desc-item-content {
  display: flex;
  flex-direction: row;
}

.book-desc-item-content-left {
  display: flex;
  flex: 1;
}

.book-desc-item-content-right {
  width: 100px;
  display: flex;
  justify-content: flex-end;
}

.book-desc-item-content-right-currency {
  font-size: 14px;
  margin-top: 5px;
  font-weight: 500px;
  color: #4d4d4d;
}

.book-desc-item-content-right-amount {
  font-size: 20px;
  color: #24a7b3;
  font-weight: 500;
}

.book-content {
  display: flex;
  flex-direction: row;
  background-color: white;
  margin-top: 10px;
}

.book-content-left {
  position: relative;
  margin: 10px 20px;
  display: flex;
  width: 70px;
  height: 100px;
}

.img-cover {
  position: absolute;
  bottom: 0;
  left: 0;
  font-size: 14px;
  background-color: rgba($color: #333, $alpha: 0.5);
  // opacity: 0.5;
  width: 70px;
  bottom: -9px;
  height: 20px;
}
.img-cover-item {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 3px;
}
.book-content-right {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
}

.book-content-right-directory {
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;

  background: linear-gradient(0deg, #269ca8 0%, #6ac6ba 100%);
  width: 67px;
  height: 30px;
  border-radius: 10px;
}

.book-content-right-directory-text {
  color: white;
}

.book-content-right-directory-wrapper {
  display: flex;
  justify-content: flex-end;
  margin: 10px 20px;
}
.book-desc-item-content-right-wrapper {
  display: flex;
  justify-content: flex-end;
  margin: 10px 20px;
}

//售卖机
.shop-sale-machine-wrapper {
  display: flex;
  flex-direction: column;
  margin-top: 2px;
  background-color: white;
}

.shop-sale-machine-title {
  font-size: 17px;
  color: #24a7b3;
  font-weight: bold;
  margin-top: 10px;
  margin-left: 20px;
}

.shop-sale-machine-item-wrapper {
  display: flex;
  margin-top: 15px;
  width: 100%;
}

.shop-sale-machine-item {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  margin-right: 20px;
  line-height: 25px;
  width: 100%;
}

.van-divider {
  margin: 0;
}

.shop-sale-machine-item-name {
  color: #333;
  font-size: 14px;
  font-weight: bold;
}

.shop-sale-machine-item-sold-name {
  color: #cccccc;
  font-size: 14px;
  font-weight: bold;
}
.shop-sale-machine-item-sold-addr {
  font-size: 12px;
  color: #cccccc;
}
.shop-sale-machine-item-addr {
  font-size: 12px;
  color: #666666;
}
.sold-out-text {
  color: #cccccc;
}
.sold-text {
  color: #333;
}
.item-sold-view {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
